import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-3 py-4" }
const _hoisted_2 = { class: "text-mild text-size-14" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-3 round-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-14 text-weight-500" }, "\n            最新版\n          ", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-black text-size-14 text-weight-500" }

import { useRoute, useRouter } from "vue-router";
import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { onMounted, ref } from "vue";
import { orderService } from "@/app/services/OrderService";
import { openInNewWindow } from "@/utils/browserUtil";
import { applicationService } from "@/app/services/ApplicationService";
import { useErrorModal } from "@/utils/modal";
import { parseISO } from "@/utils/date";

type NoticeOfEmployment = {
  archivedAt: string;
  archiveId: number;
  version: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeOfEmploymentsList',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const errorModal = useErrorModal();
const noticeOfEmployments = ref<NoticeOfEmployment[]>([]);
const workTime = ref<string>("労働条件通知書");
const orderTitle = ref<string>("");

onMounted(async () => {
  try {
    const application = await applicationService.fetchApplication(
      Number(route.params.applicationId)
    );

    workTime.value =
      orderService.getFormattedDateWithSlash(application.order) +
      " " +
      applicationService.getFormattedWorkTimeRange(application);
    orderTitle.value = application.order.title;
    const pdfVersions = await orderService.getNoticeOfEmploymentArchiveList(
      Number(route.params.applicationId)
    );
    noticeOfEmployments.value = pdfVersions
      .map(item => {
        return {
          archivedAt: item.archivedAt,
          archiveId: item.archiveId,
          version: item.version
        };
      })
      .sort((a, b) => descSort(a.version, b.version));
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  }
});

const onBack = () => {
  router.back();
};

const downloadPdf = async (archiveId: number) => {
  try {
    const res = await orderService.getArchivedNoticeOfEmploymentPdfUrl(
      Number(route.params.applicationId),
      archiveId
    );
    openInNewWindow(res.url);
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  }
};

const downloadLatestPdf = async () => {
  try {
    const res = await orderService.getFixedNoticeOfEmploymentPdfUrl(
      Number(route.params.applicationId)
    );
    openInNewWindow(res.url);
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  }
};

function descSort(a: number, b: number) {
  return a < b ? 1 : -1;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n    労働条件通知書\n  ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(workTime.value) + "「" + _toDisplayString(orderTitle.value) + "」", 1),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            target: "_blank",
            role: "button",
            class: "d-flex justify-content-between align-items-center py-3",
            onClick: downloadLatestPdf
          }, [
            _hoisted_4,
            _createTextVNode(),
            _createVNode(FeatherIcon, {
              icon: "chevron-right",
              class: "text-gray-05"
            })
          ])
        ]),
        _createTextVNode(),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeOfEmployments.value, (noticeOfEmployment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: noticeOfEmployment.archiveId
          }, [
            _createElementVNode("a", {
              target: "_blank",
              role: "button",
              class: "d-flex justify-content-between align-items-center py-3",
              onClick: ($event: any) => (downloadPdf(noticeOfEmployment.archiveId))
            }, [
              _createElementVNode("p", _hoisted_6, "\n            第" + _toDisplayString(noticeOfEmployment.version) + "版\n          ", 1),
              _createTextVNode(),
              _createVNode(FeatherIcon, {
                icon: "chevron-right",
                class: "text-gray-05"
              })
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})